import { memo, useCallback } from 'react';
import type { FormSearchPredicateData } from '@/services/api-types';
import type { FormFilterBaseProps } from './filter-base';

export interface TextFilterProps extends FormFilterBaseProps {}

/**
 * Single text input filter. Emits `{op: 'CONTAINS', value: input}` when
 * non-empty, or `[]` when empty.
 *
 * Uses the Records Search `.field` row pattern so spacing and label styling
 * match the surrounding native filters (Client Name, Address, Website).
 */
export const TextFilter = memo(function TextFilter({
  field,
  predicates,
  onPredicatesChange,
}: TextFilterProps) {
  const existing = predicates.find((p) => p.op === 'CONTAINS');
  const currentValue = existing && typeof existing.value === 'string' ? existing.value : '';

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const next = e.target.value;
      if (next === '') {
        onPredicatesChange([]);
        return;
      }
      const predicate: FormSearchPredicateData = {
        fieldKey: field.key,
        op: 'CONTAINS',
        value: next,
      };
      onPredicatesChange([predicate]);
    },
    [field.key, onPredicatesChange],
  );

  return (
    <div className="field">
      <label htmlFor={`form-filter-${field.key}`}>{field.label}</label>
      <input
        id={`form-filter-${field.key}`}
        type="text"
        value={currentValue}
        onChange={handleChange}
        placeholder={`Enter ${field.label}`}
      />
    </div>
  );
});
